<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>Dashboard</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <!-- <div class="action-btn">
                                    <button pButton pRipple label="" icon="las la-plus" title="Add" 
                                        class="p-button-success p-mr-2"></button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                        <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                </ng-template>
                            </p-toolbar>

                            <!-- <p-table #dt [value]="agentListGrid" [scrollable]="true" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']"
                                [style]="{'overflow':'auto!important'}" [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" scrollHeight="200px"> -->
                                <p-table #dt [value]="PreQuoteListGrid" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]" [columns]="cols"
                                [globalFilterFields]="['customercode','customername','pan','customername','istransporter','companytype','prequotestatus','modifiedby','modifiedon']"
                                [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                 [showCurrentPageReport]="true" [scrollable]="true">
                                 <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:180px">
                                        <col style="width:150px">
                                        <col style="width:300px">
                                        <col style="width:150px">
                                        <col style="width:170px">
                                        <!--col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px"-->
                                    </colgroup>
                                </ng-template> 
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="customercode">Customer ID <p-sortIcon field="customercode">
                                        </p-sortIcon>
                                    </th>
                                        <th pSortableColumn="customername" style="width:12%">Customer Name <p-sortIcon field="customername"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="pan">PAN <p-sortIcon field="pan"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="istransporter">Is Transporter <p-sortIcon field="istransporter"></p-sortIcon>
                                        </th>
                                        
                                        <th pSortableColumn="companytype">Company Type <p-sortIcon field="companytype">
                                            </p-sortIcon>
                                        </th>                                                                       
                                        <th pSortableColumn="billingcycle">Billing Cycle <p-sortIcon field="billingcycle">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="prequotestatus" style="width:13%">Pre-Quote Status <p-sortIcon field="prequotestatus"></p-sortIcon>
                                        </th>                                       
                                        <th pSortableColumn="modifiedby">Updated by <p-sortIcon field="modifiedby"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="modifiedon">Updated On <p-sortIcon field="modifiedon"></p-sortIcon>
                                        </th>                                        
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_DashboardListGrid>
                                    <tr>
                                        <td>
                                            {{_DashboardListGrid.customercode}}
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.customername}}
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.pan}}
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.istransporter}}
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.companytype}}
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.billingcycle}}
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.prequotestatus}}
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.modifiedby}}
                                        </td>
                                        <td>
                                            {{_DashboardListGrid.modifiedon}}
                                        </td>                                       
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
